module.exports = "/**\r\n * @license\r\n * Copyright Akveo. All Rights Reserved.\r\n * Licensed under the MIT License. See License.txt in the project root for license information.\r\n */\n:host .title {\n  margin-bottom: 2rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/framework/auth/components/register/register.component.scss
// module id = ./src/framework/auth/components/register/register.component.scss
// module chunks = main